/**
 * @file index.js
 * @author Daniel Aguirre
 * @description Initialize PsychosocialRisk List View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './PsychosocialRiskListView';

export const mapStateToPropsPsychosocialRiskList = mapStateToProps;
export const mapDispatchToPropsPsychosocialRiskList = mapDispatchToProps;

export default connect(
  mapStateToPropsPsychosocialRiskList,
  mapDispatchToPropsPsychosocialRiskList
)(View);
